import http from "@/assets/js/http.js";
import modal from "@/assets/js/modal.js";
import moment from "moment";

const state = () => ({
    filter: {
        keyword: null,
        requested: false,
        start_date: moment(new Date).format("YYYY-MM-DD"),
        end_date: moment(new Date).format("YYYY-MM-DD"),
        driver_id: [],
    },
    response: {
        data: [],
        meta: [],
    },
    modal: {
        filter: {
            backdrop: false,
            modal: false,
            data: {},
        }
    },
})

const mutations = {
}

const actions = {
    triggerModal({ state }, payload) {
        return modal.trigger(state, payload)
    },
    getDistributionHistory({ state }, payload = null) {
        return http.get('distribusi_report/report/distribusi_history', state, payload)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
